import { render, staticRenderFns } from "./IRDebtInvestorsPage.vue?vue&type=template&id=b2f9123c"
import script from "./IRDebtInvestorsPage.vue?vue&type=script&lang=js"
export * from "./IRDebtInvestorsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports